@if (hasMultipleCompanyAccess()) {
  @if (appState().session; as userSession) {
    <div
      class="border border-gray-200 rounded py-1 px-4 cursor-pointer"
      (menuOpened)="onSwitcherOpenedAsync()"
      [matMenuTriggerFor]="menu"
    >
      {{ userSession.company?.name }}

      <fa-icon [icon]="faCaretDown" class="ms-2" />
    </div>

    <mat-menu #menu="matMenu">
      @if (availableCompanies()) {
        @for (company of availableCompanies(); track company.id) {
          @if (company.id !== userSession.company?.companyId) {
            <button
              (click)="switchCompanyAsync(company)"
              mat-menu-item
            >
              {{ company.name }}
            </button>
          }
        }
      } @else {
        <app-loading-indicator mode="centered" />
      }
    </mat-menu>
  }
}
